import TemplateCategoryRow from './TemplateCategoryRow';
import {deleteTemplateCategoryAction, showNotificationAction, updateTemplateCategoryAction} from '../../app/actions';
import {connect} from '../../app/connect';
import {getTemplateCategoryTitlesForUniqueValidation} from '../../app/templates/template-selectors';
import {getIsTemplateCategoryLoading} from '../../utils/issue-template-helpers';

const mapStateToProps = (state, ownProps) => ({
  templateCategoryTitles: getTemplateCategoryTitlesForUniqueValidation(state),
  isLoading: getIsTemplateCategoryLoading(state, ownProps.category.id)
});

const mapDispatchToProps = {
  updateTemplateCategoryAction,
  deleteTemplateCategoryAction,
  showNotificationAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateCategoryRow);
